var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row m-t-5 row-center"},[_c('div',{staticClass:"column large-8 medium-10 small-11 xsmall-12"},[_c('video-player',{attrs:{"url":_vm.video}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }